import { useQuery } from 'react-query';

import { handleRefreshToken } from 'utils/refreshToken';
import { API_URL, HEADER_ACCEPT_HR } from 'utils/apiConstants';
import { FetchError } from 'utils/FetchError';
import { GetAccessListData, GetAccessListParams } from 'interfaces/hooks/permissionsHooksInterfaces';

export const useGetAccessList = ({ isLoggedIn, onError }: GetAccessListParams): GetAccessListData => {
  const { data: accessList } = useQuery(
    ['access_list', isLoggedIn],
    async () => {
      await handleRefreshToken();

      const token = localStorage.getItem('token');

      const res = await fetch(`${API_URL}/companies/access_control_list/`, {
        method: 'GET',
        headers: {
          Accept: `${HEADER_ACCEPT_HR}`,
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.ok) {
        return res.json();
      }
      throw new FetchError(res);
    },
    {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      enabled: isLoggedIn,
      onError,
      select: (res) => res?.data
    }
  );

  return { accessList };
};
